import git from "./Git/icons8-git-96.png";
import cSharp from "./C/icons8-c-96.png";
import css from "./CSS3-48-96px/icons8-css3-96.png";
import html from "./Html 5-48-96px/icons8-html-5-96.png";
import js from "./JavaScript-48-96px/icons8-javascript-96.png";
import typescript from "./Typescript/icons8-typescript-96.png";
import mongodb from "./MongoDB-48-96px/icons8-mongodb-96.png";
import npm from "./NPM-48-96px/icons8-npm-96.png";
import react from "./React Native-48-96px/icons8-react-native-96.png";
import postgress from "./Postgress/icons8-postgresql-96.png";
import github from "./Github/icons8-github-96.png";
import linkedIn from "./LinkedIn/icons8-linkedin-96.png";
import API from "./API-48-96px/icons8-api-48.png";
import Python from "./Python/icons8-python-96.png";

export const gitBadge = git;

export const cSharpBadge = cSharp;

export const cssBadge = css;

export const htmlBadge = html;

export const jsBadge = js;

export const typescriptBadge = typescript;

export const mongodbBadge = mongodb;

export const npmBadge = npm;

export const reactBadge = react;

export const postgressBadge = postgress;

export const githubBadge = github;

export const linkedInBadge = linkedIn;

export const api = API;

export const python = Python;
